import { FC, Dispatch, SetStateAction } from "react";

interface ICollapsables {
  information_for_ordering_offices: boolean;
  terms_and_conditions: boolean;
  labor_category_descriptions: boolean;
  labor_rates: boolean;
}

interface IProps {
  isCollapsed: ICollapsables;
  setIsCollapsed: Dispatch<SetStateAction<ICollapsables>>;
}

export const TermsAndConditions: FC<IProps> = ({
  isCollapsed,
  setIsCollapsed,
}) => {
  return (
    <div className="Contract__wrapper__section">
      <h2
        onClick={() =>
          setIsCollapsed({
            ...isCollapsed,
            terms_and_conditions: !isCollapsed.terms_and_conditions,
          })
        }
        className="collapsable"
      >
        Terms & Conditions
        <i
          className={
            isCollapsed.terms_and_conditions
              ? "fas fa-caret-down"
              : "fas fa-caret-up"
          }
        ></i>
      </h2>
      <div
        className={`Contract__wrapper__section__content ${
          isCollapsed.terms_and_conditions ? "hidden" : ""
        }`}
      >
        <div className="collapse-wrapper">
          <button
            onClick={() =>
              setIsCollapsed({
                ...isCollapsed,
                terms_and_conditions: true,
              })
            }
            className="collapse-section"
          >
            Collapse section
          </button>
        </div>
        <div className="general_info">
          <span>GSA Contract Number - GS-35F-068GA</span>
          <span>Professional Software Engineering, Inc. (t/a PROSOFT)</span>
          <div className="general_info__contact">
            <span>500 Viking Drive, Suite 301</span>
            <span>Virginia Beach, VA 23452-7477</span>
            <span>(757) 431-2400</span>
          </div>
          <span className="general_info__subheader">
            TERMS AND CONDITIONS APPLICABLE TO INFORMATION TECHNOLOGY (IT)
            PROFESSIONAL SERVICES
          </span>
        </div>
        <div className="notice">
          <p>(SPECIAL ITEM NUMBER 132-51)</p>
          <ol>
            <li>Scope</li>
            <p>
              a. The prices, terms and conditions stated under Special Item
              Number 132-51 Information Technology Professional Services apply
              exclusively to IT Services within the scope of this Information
              Technology Schedule.
            </p>
            <p>
              b. The Contractor shall provide services at the Contractor's
              facility and/or at the Government location, as agreed to by the
              Contractor and the ordering office.
            </p>
            <li>PERFORMANCE INCENTIVES</li>
            <p>
              a. When using a performance based statement of work, performance
              incentives may be agreed upon between the contractor and the
              ordering office on individual fixed price orders or Blanket
              Purchase Agreements, for fixed price tasks, under this contract in
              accordance with this clause.
            </p>
            <p>
              b. The ordering office must establish a maximum performance
              incentive price for these services and/or total solutions on
              individual orders or Blanket Purchase Agreements.
            </p>
            <p>
              c. To the maximum extent practible, ordering offices shall
              consider establishing incentives where performance is critical to
              the agency's mission and incentives are likely to motivate the
              contractor. Incentives shall be based on objectively measurable
              tasks.
            </p>
            <p>
              d. The above procedures do not apply to Time and Material or labor
              hour orders.
            </p>
            <li>
              ORDERING PROCEDURES FOR SERVICES (REQUIRING A STATEMENT OF WORK)
            </li>
            <p>
              FAR 8.402 contemplates that GSA may occasionally find it necessary
              to establish special ordering procedures for individual Federal
              Supply Schedules or for some Special Item Numbers (SINs) within a
              Schedule. GSA has established special ordering procedures for
              services that require a statement of work. These special ordering
              procedures take precedence over the procedures in FAR 8.404 (b)(2)
              through (b)(3).
            </p>
            <p>
              GSA has determined that the prices for services contained in the
              contractor's price list applicable to this schedule are fair and
              reasonable. However, the ordering office using this contract is
              responsible for considering the level of effort and mix of labor
              proposed to perform a specific task being ordered and for making a
              determination that the total firm-fixed price or ceiling price is
              fair and reasonable.
            </p>
            <p>
              a. When ordering IT professional services ordering offices shall -
            </p>
            <p>
              (1) Prepare a Request (Request for Quote or other communication
              tool):
            </p>
            <p>
              (i) A statement of work (a performance-based statement of work is
              preferred) that outlines, at a minimum, the work to be performed,
              location of work, period of performance, deliverable schedule,
              applicable standards, acceptance criteria, and any special
              requirements (i.e., security clearances, travel, special
              knowledge, etc.) should be prepared.
            </p>
            <p>
              (ii) The request should include the statement of work and request
              the contractors submit either a firm-fixed price or a ceiling
              price to provide the services outlined in the statement of work. A
              firm-fixed price order shall be requested, unless the ordering
              office makes a determination that it is not possible at the time
              of placing the order to estimate accurately the extent or duration
              of the work or to anticipate cost with any reasonable degree of
              confidence. When such a determination is made, a labor hour or
              time-and-materials proposal may be requested. The firm-fixed price
              shall be based on the rates in the schedule contract and shall
              consider the mix of labor categories and level of effort required
              to perform the services described in the statement of work. The
              firm-fixed price of the order should also include any travel costs
              or other incidental costs related to performance of the services
              ordered, unless the order provides for reimbursement of travel
              costs at the rates provided in the Federal Travel or Joint Travel
              Regulations. A ceiling price must be established for labor hour
              and time and material orders.
            </p>
            <p>
              (iii) The request may ask the contractors, if necessary or
              appropriate, to submit a project plan for performing the task and
              information on the contractor's experience and/or past performance
              performing similar tasks.
            </p>
            <p>
              (iv) The request shall notify the contractors what basis will be
              used for selecting the contractor to receive the order. The notice
              shall include the basis for determining whether the contractors
              are technically qualified and provide an explanation regarding the
              intended use of any experience and/or past performance information
              in determining technical qualification of responses. If
              consideration will be limited to schedule contractors who are
              small business concerns as permitted by paragraph (2)(i) below,
              the request shall notify the contractors that will be the case.
            </p>
            <p>(2) Transmit the Request to Contractors:</p>
            <p>
              (i) Based upon an initial evaluation of catalogs and pricelists,
              the ordering office should identify the contractors that appear to
              offer the best value (considering the scope of services offered,
              pricing and other factors such as contractors' locations, as
              appropriate). When buying IT professional services under SIN
              132-51 ONLY, the ordering office, at its discretion, may limit
              consideration to those schedule contractors that are small
              business concerns. This limitation is not applicable when buying
              supplies and/or services under other SINs as well as SIN 132-51.
              The limitation may only be used when at least three (3) small
              businesses that appear to offer services that will meet the
              agency's needs are available, if the order is estimated to exceed
              the micro-purchase threshold.
            </p>
            <p>
              (ii) The request should be to three (3) contractors if the
              proposed order is estimated to exceed the micro-purchase
              threshold, but not to exceed the maximum order threshold. For
              proposed orders exceeding the maximum order threshold, the request
              should be provided to additional contractors that offer services
              that will meet the agency's needs. Ordering offices should strive
              to minimize the contractors' costs associated with responding to
              requests for quotes for specific orders. Requests should be
              tailored to the minimum level necessary for adequate evaluation
              and selection for order placement. Oral presentations should be
              considered, when possible.
            </p>
            <p>
              (3) Evaluate proposals and select the contractor to receive the
              order:
            </p>
            <p>
              After responses have been evaluated against the factors identified
              in the request, the order should be placed with the schedule
              contractor that represents the best value. (See FAR 8.404)
            </p>
            <p>
              b. The establishment of Federal Supply Schedule Blanket Purchase
              Agreements (BPAs) for recurring services is permitted when the
              procedures outlined herein are followed. All BPAs for services
              must define the services that may be ordered under the BPA, along
              with delivery or performance time frames, billing procedures, etc.
              The potential volume of orders under BPAs, regardless of the size
              of individual orders, may offer the ordering office the
              opportunity to secure volume discounts. When establishing BPAs,
              ordering offices shall -
            </p>
            <p>
              (1) Inform contractors in the request (based on the agency's
              requirement) if a single BPA or multiple BPAs will be established,
              and indicate the basis that will be used for selecting the
              contractors to be awarded the BPAs.
            </p>
            <p>
              (i) SINGLE BPA: Generally, a single BPA should be established when
              the ordering office can define the tasks to be ordered under the
              BPA and establish a firm-fixed price or ceiling price for
              individual tasks or services to be ordered. When this occurs,
              authorized users may place the order directly under the
              established BPA when the need for service arises. The schedule
              contractor that represents the best value should be awarded the
              BPA. (See FAR 8.404
            </p>
            <p>
              (ii) MULTIPLE BPAs: When the ordering office determines multiple
              BPAs are needed to meet its requirements, the ordering office
              should determine which contractors can meet any technical
              qualifications before establishing the BPAs. When multiple BPAs
              are established, the authorized users must follow the procedure in
              (a)(2)(ii) above, and then place the order with the schedule
              contractor that represents the best value.
            </p>
            <p>
              (2) Review BPAs periodically. Such reviews shall be conducted at
              least annually. The purpose of the review is to determine whether
              the BPA still represents the best value. (See FAR 8.404)
            </p>
            <p>
              c. The ordering office should give preference to small business
              concerns when two or more contractors can provide the services at
              the same firm-fixed price or ceiling price.
            </p>
            <p>
              d. When the ordering office's requirement involves both products
              as well as executive, administrative and/or professional services,
              the ordering office should total the prices for the products and
              the firm-fixed price for the services and select the contractor
              that represents the best value. (See FAR 8.404)
            </p>
            <p>
              The ordering office, at a minimum, should document orders by
              identifying the contractor from which the services were purchased,
              the services purchased, and the amount paid. If other than a
              firm-fixed price order is placed, such documentation should
              include the basis for the determination to use a labor-hour or
              time-and-materials order. For agency requirements in excess of the
              micro-purchase threshold, the order file should document the
              evaluation of schedule contractors' quotes that formed the basis
              for the selection of the contractor that received the order and
              the rationale for any trade-offs made in making the selection.
            </p>
            <p>
              Ordering Procedures for other services available on schedule at
              fixed prices for specifically defined services or tasks should use
              the procedures in FAR 8.404. These procedures are listed in the
              pricelist, under "Information for Ordering Offices," paragraph
              #12.
            </p>
            <li>ORDER</li>
            <p>
              a. Agencies may use written orders, EDI orders, blanket purchase
              agreements, individual purchase orders, or task orders for
              ordering services under this contract. Blanket Purchase Agreements
              shall not extend beyond the end of the contract period; all
              services and delivery shall be made and the contract terms and
              conditions shall continue in effect until the completion of the
              order. Orders for tasks which extend beyond the fiscal year for
              which funds are available shall include FAR 52.232-19 Availability
              of Funds for the Next Fiscal Year. The purchase order shall
              specify the availability of funds and the period for which funds
              are available.
            </p>
            <p>
              b. All task orders are subject to the terms and conditions of the
              contract. In the event of conflict between a task order and the
              contract, the contract will take precedence.
            </p>
            <li>PERFORMANCE OF SERVICES</li>
            <p>
              a. The Contractor shall commence performance of services on the
              date agreed to by the Contractor and the ordering office.
            </p>
            <p>
              b. The Contractor agrees to render services only during normal
              working hours, unless otherwise agreed to by the Contractor and
              the ordering office.
            </p>
            <p>
              c. The Agency should include the criteria for satisfactory
              completion for each task in the Statement of Work or Delivery
              Order. Services shall be completed in a good and workmanlike
              manner.
            </p>
            <p>
              d. Any Contractor travel required in the performance of IT
              Services must comply with the Federal Travel Regulation or Joint
              Travel Regulations, as applicable, in effect on the date(s) the
              travel is performed. Established Federal Government per diem rates
              will apply to all Contractor travel. Contractors cannot use GSA
              city pair contracts.
            </p>
            <li>INSPECTION OF SERVICES</li>
            <p>
              The Inspection of Services-Fixed Price (AUG 1996) clause at FAR
              52.246-4 applies to firm-fixed price orders placed under this
              contract. The Inspection-Time-and-Materials and Labor-Hour (JAN
              1986) clause at FAR 52.246-6 applies to time-and-materials and
              labor-hour orders placed under this contract.
            </p>
            <li>RESPONSIBILITIES OF THE CONTRACTOR</li>
            <p>
              The Contractor shall comply with all laws, ordinances, and
              regulations (Federal, State, City, or otherwise) covering work of
              this character. If the end product of a task order is software,
              then FAR 52-.227-14 Rights in Data - General, may apply.
            </p>
            <li>RESPONSIBILITIES OF THE GOVERNMENT</li>
            <p>
              Subject to security regulations, the ordering office shall permit
              Contractor access to all facilities necessary to perform the
              requisite IT Services.
            </p>
            <li>INDEPENDENT CONTRACTOR</li>
            <p>
              All IT Services performed by the Contractor under the terms of
              this contract shall be as an independent Contractor, and not as an
              agent or employee of the Government.
            </p>
            <li>ORGANIZATIONAL CONFLICTS OF INTEREST</li>
            <p>a. Definitions.</p>
            <p>
              "Contractor" means the person, firm, unincorporated association,
              joint venture, partnership, or corporation that is a party to this
              contract.
            </p>
            <p>
              "Contractor and its affiliates" and "Contractor or its affiliates"
              refers to the Contractor, its chief executives, directors,
              officers, subsidiaries, affiliates, subcontractors at any tier,
              and consultants and any joint venture involving the Contractor,
              any entity into or with which the Contractor subsequently merges
              or affiliates, or any other successor or assignee of the
              Contractor.
            </p>
            <p>
              An "Organizational conflict of interest" exists when the nature of
              the work to be performed under a proposed Government contract,
              without some restriction on activities by the Contractor and its
              affiliates, may either (i) result in an unfair competitive
              advantage to the Contractor or its affiliates or (ii) impair the
              Contractor's or its affiliates' objectivity in performing contract
              work.
            </p>
            <p>
              b. To avoid an organizational or financial conflict of interest
              and to avoid prejudicing the best interests of the Government,
              ordering offices may place restrictions on the Contractors, its
              affiliates, chief executives, directors, subsidiaries and
              subcontractors at any tier when placing orders against schedule
              contracts. Such restrictions shall be consistent with FAR 9.505
              and shall be designed to avoid, neutralize, or mitigate
              organizational conflicts of interest that might otherwise exist in
              situations related to individual orders placed against the
              schedule contract. Examples of situations, which may require
              restrictions, are provided at FAR 9.508.
            </p>
            <li>INVOICES</li>
            <p>
              The Contractor, upon completion of the work ordered, shall submit
              invoices for IT services. Progress payments may be authorized by
              the ordering office on individual orders if appropriate. Progress
              payments shall be based upon completion of defined milestones or
              interim products. Invoices shall be submitted monthly for
              recurring services performed during the preceding month.
            </p>
            <li>PAYMENTS</li>
            <p>
              For firm-fixed price orders the Government shall pay the
              Contractor, upon submission of proper invoices or vouchers, the
              prices stipulated in this contract for service rendered and
              accepted. Progress payments shall be made only when authorized by
              the order. For time-and-materials orders, the Payments under
              Time-and-Materials and Labor-Hour Contracts (Alternate I (APR
              1984)) at FAR 52.232-7 applies to time-and-materials orders placed
              under this contract. For labor-hour orders, the Payment under
              Time-and-Materials and Labor-Hour Contracts (FEB 1997) (Alternate
              II (JAN 1986)) at FAR 52.232-7 applies to labor-hour orders placed
              under this contract.
            </p>
            <li>RESUMES</li>
            <p>
              Resumes shall be provided to the GSA Contracting Officer or the
              user agency upon request.
            </p>
            <li>INCIDENTAL SUPPORT COSTS</li>
            <p>
              Incidental support costs are available outside the scope of this
              contract. The costs will be negotiated separately with the
              ordering agency in accordance with the guidelines set forth in the
              FAR.
            </p>
            <li>APPROVAL OF SUBCONTRACTS</li>
            <p>
              The ordering activity may require that the Contractor receive,
              from the ordering activity's Contracting Officer, written consent
              before placing any subcontract for furnishing any of the work
              called for in a task order.
            </p>
            <span className="text-center bold">
              TERMS AND CONDITIONS APPLICABLE TO ORDER-LEVEL MATERIALS (OLM)
              (SPECIAL ITEM NUMBER 70-500)
            </span>
            <p>The SIN Description is as follows -</p>
            <ol className="inner-list">
              <li>
                Order-Level Materials (OLMs) are supplies and/or services
                acquired in direct support of an individual task or delivery
                order placed against a Federal Supply Schedule (FSS) contract or
                FSS blanket purchase agreement (BPA). OLMs are not defined,
                priced, or awarded at the FSS contract level. They are unknown
                before a task or delivery order is placed against the FSS
                contract or FSS BPA. OLMs are only authorized for inclusion at
                the order level under a Time-and-Materials (T&M) or Labor-Hour
                (LH) Contract Line Item Number (CLIN) and are subject to a Not
                To Exceed (NTE) ceiling price. OLMs include direct materials,
                subcontracts for supplies and incidental services for which
                there is not a labor category specified in the FSS contract,
                other direct costs (separate from those under ODC SINs), and
                indirect costs. OLMs are purchased under the authority of the
                FSS Program and are not "open market items."
              </li>
              <li>
                Items awarded under ancillary supplies/services or other direct
                cost (ODC) SINs are not OLMs. These items are defined, priced,
                and awarded at the FSS contract level, whereas OLMs are unknown
                before an order is placed. Ancillary supplies/services and ODC
                SINs are for use under all order type CLINs (Fixed-Price (FP),
                T&M, and LH), whereas the Order-Level Materials SIN is only
                authorized for use under T&M and LH order CLINs.
              </li>
              <li>
                The Order-Level Materials SIN is only authorized for use in
                direct support of another awarded SIN. Price analysis for OLMs
                is not conducted when awarding the FSS contract or FSS BPA;
                therefore, GSAR 538.270 and 538.271 do not apply to OLMs. OLMs
                are defined and priced at the ordering activity level in
                accordance with GSAR clause 552.238-82 Special Ordering
                Procedures for the Acquisition of Order-Level Materials. Prices
                for items provided under the Order-Level Materials SIN must be
                inclusive of the Industrial Funding Fee (IFF). The cumulative
                value of OLMs in an individual task or delivery order cannot
                exceed 33.33% of the total value of the order.
              </li>
              <li>The Maximum Order Threshold for the OLM SINs is $100,000.</li>
              <li>
                See clauses 552.212-4 Contract Terms and Conditions - Commercial
                Items (JAN 2017) (Deviation - FEB 2018) (Alternate I - JAN 2017)
                (Deviation - FEB 2007) and 552.238-82 Special Ordering
                Procedures for the Acquisition of Order-Level Materials (JAN
                2018) for additional information on inclusion of OLMs in task
                and delivery orders placed against an FSS contract or BPA.
              </li>
              <li>
                OLMs are only authorized for inclusion at the order level under
                a T&M or LH CLIN and are subject to an NTE ceiling price.
              </li>
              <li>
                The Order-Level Materials SIN contains no items or pricing,
                since by definition OLMs are unknown at the time of FSS contract
                award. The ordering activity contracting officer is responsible
                for defining OLMs and determining proposed OLM pricing fair and
                reasonable for a particular order.
              </li>
              <li>
                OLMs are purchased under the authority of the FSS Program and
                are not "open market items."
              </li>
              <li>
                Items awarded under ancillary supplies/services and other direct
                cost (ODC) SINs are not Order-Level Materials. These SINs are
                reserved for items that can be defined and priced up-front at
                the FSS contract level.
              </li>
              <li>
                The Order-Level Materials SIN cannot be the only SIN awarded on
                a contract. The Order-Level Materials SIN is only authorized for
                use in direct support of another awarded SIN.
              </li>
              <li>
                The Order-Level Materials SIN is exempt from Commercial Sales
                Practices disclosure requirements.
              </li>
              <li>
                The Order-Level Materials SIN is exempt from the following
                clauses:
                <ul className="inner-list__inner">
                  <li>
                    552.216-70 Economic Price Adjustment - FSS Multiple Award
                    Schedule Contracts
                  </li>
                  <li>
                    I-FSS-969 Economic Price Adjustment - FSS Multiple Award
                    Schedule
                  </li>
                  <li>
                    552.238-71 Submission and Distribution of Authorized FSS
                    Schedule Pricelists, 552.238-75 Price Reductions
                  </li>
                </ul>
              </li>
              <li>
                Terms and conditions that otherwise apply to the FSS contract
                also apply to the Order-Level Materials SIN. Examples include
                but are not limited to:
                <ul className="inner-list__inner">
                  <li>Trade Agreements Act (TAA)</li>
                  <li>Sales reporting and IFF remittance</li>
                  <li>Environmental Attributes clauses</li>
                  <li>
                    AbilityOne Program Essentially the Same (ETS) compliance
                  </li>
                </ul>
              </li>
              <li>
                The Order-Level Materials SIN is subject to any transactional
                data reporting (TDR) requirements in effect under the FSS
                contract.
              </li>
              <li>
                Prices for items provided under the Order-Level Materials SIN
                must be inclusive of the IFF. The cumulative value of OLMs in an
                individual task or delivery order cannot exceed 33.33% of the
                total value of the order.
              </li>
              <li>
                The following clause is ADDED to this contract:
                <ul className="inner-list__inner">
                  <li>
                    552.238-82 Special Ordering Procedures for the Acquisition
                    of Order-Level Materials (JAN 2018)
                  </li>
                </ul>
              </li>
            </ol>
            <p>
              USA COMMITMENT TO PROMOTE SMALL BUSINESS PARTICIPATION PROCUREMENT
              PROGRAMS PREAMBLE
            </p>
            <p>
              Professional Software Engineering, Inc. (t/a PROSOFT) provides
              commercial products and services to the Federal Government. We are
              committed to promoting participation of small, small disadvantaged
              and women-owned small businesses in our contracts. We pledge to
              provide opportunities to the small business community through
              reselling opportunities, mentor-protégé programs, joint ventures,
              teaming arrangements, and subcontracting.
            </p>
            <p>COMMITMENT</p>
            <p>To actively seek and partner with small businesses.</p>
            <p>
              To identify, qualify, mentor and develop small, small
              disadvantaged and women-owned small businesses by purchasing from
              these businesses whenever practical.
            </p>
            <p>
              To develop and promote company policy initiatives that demonstrate
              our support for awarding contracts and subcontracts to small
              business concerns.
            </p>
            <p>
              To undertake significant efforts to determine the potential of
              small, small disadvantaged and women-owned small business to
              supply products and services to our company.
            </p>
            <p>
              To insure procurement opportunities are designed to permit the
              maximum possible participation of small, small disadvantaged, and
              women-owned small businesses.
            </p>
            <p>
              To attend business opportunity workshops, minority business
              enterprise seminars, trade fairs, procurement conferences, etc.,
              to identify and increase small businesses with whom to partner.
            </p>
            <p>
              To publicize in our marketing publications our interest in meeting
              small businesses that may be interested in subcontracting
              opportunities.
            </p>
            <p>
              We signify our commitment to work in partnership with small, small
              disadvantaged and women-owned small businesses to promote and
              increase their participation in Federal Government contracts. To
              accelerate potential opportunities please contact:
            </p>
            <div className="contact text-center">
              <span className="underline">Phil Eagan</span>
              <span>phone: 757-431-2400 x 1643</span>
              <span>mobile: 757-636-0420</span>
              <span>fax: 757-463-1071</span>
            </div>
          </ol>
        </div>
      </div>
    </div>
  );
};
